/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type InternalDeleteExperimentStratifiedSamplingPathParams = NonNullable<
  operations['internalDeleteExperimentStratifiedSampling']['parameters']['path']
>;

export interface Input extends InternalDeleteExperimentStratifiedSamplingPathParams {
  apiVersion?: string;
  header: NonNullable<operations['internalDeleteExperimentStratifiedSampling']['parameters']['header']>;
}

export async function internalDeleteExperimentStratifiedSampling(
  { apiVersion, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().DELETE(
    '/internal/projects/{projectKey}/environments/{environmentKey}/experiments/{experimentKey}/stratified-sampling/{covariateId}',
    {
      params: { path, header },
      headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
      signal,
    },
  );
}
